// Definição para o modal de busca de Logs de Erro (para vincular a tratamentos)
export const configBuscaErrorLog = {
  label: 'Log de Erro',
  placeholder: 'ID ou mensagem...',
  titulo: 'Buscar Log de Erro',
  endpointApi: 'ErrorLogs',
  idField: 'idErrorLog',
  displayField: 'idErrorLog',
  descField: 'message',

  camposFiltro: [
    { label: 'ID', model: 'idErrorLog', tipo: 'number' },
    { label: 'Mensagem', model: 'message', tipo: 'text' },
    { label: 'Tipo', model: 'exceptionType', tipo: 'text' },
    {
      label: 'Origem',
      model: 'origem',
      tipo: 'select',
      opcoes: [
        { value: 'Backend', label: 'Backend' },
        { value: 'Frontend', label: 'Frontend' }
      ]
    }
  ],

  colunasGrid: [
    { header: 'ID', dataField: 'idErrorLog', width: '8%' },
    { header: 'Data', dataField: 'tsCriacao', width: '15%' },
    { header: 'Tipo', dataField: 'exceptionType', width: '20%' },
    { header: 'Mensagem', dataField: 'message', width: '40%' },
    { header: 'Origem', dataField: 'origem', width: '10%' }
  ]
}
